import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import noimage from 'assets/images/noimage.png'
import CustomButton from 'components/Buttons/CustomButton'
import ExpandableNoteList from 'components/ExpandableNoteList'
import PMBImageWithToken from 'components/PMBImageWithToken'
import PMBModalImagePreview from 'components/PMBModalImagePreview'
import PMBPagination from 'components/PMBPagination'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import { TableComponent } from 'components/TableComponent'
import { Can } from 'context/Acl'
import { useDebounce } from 'helpers'
import { useEffect, useState } from 'react'
import { ChevronDown, Clock, Download, Edit, MapPin } from 'react-feather'
import { PMBDateRangePicker } from 'components/PMBNewDatePicker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Card, CardBody, Col, Modal, ModalBody, Row } from 'reactstrap'
import {
  formatDateOnlyPMB,
  formatDuration,
  formatTimeOnlyPMB,
} from 'utils/formatDate'
import { BUSINESS_ATTENDANCE_DASHBOARD, MANAGE } from 'utils/subjectActions'
import ModalEditAttendance from './ModalEditAttendance'
import ModalVerifyAttendance from './ModalVerifikasi'
import {
  setFetchOption,
  toggleModal,
  toggleModalVerify,
} from './reportAttendanceSlice'
import PMBProgressBarExportFile from 'components/PMBProgressBarExportFile'
import { handleDownloadExcel } from './downloadAttendance'
import { useLazyFetchAttendanceReportQuery } from './reportAttendanceApiSlice'
import moment from 'moment-timezone'

const TableReport = (props) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [triggerFetchForDownload] = useLazyFetchAttendanceReportQuery()
  const dataState = location.state
  const { loading, tag } = useSelector((s) => s.reportAttendance)
  const [searchInput, setSearchInput] = useState('')
  const [urlImage, setUrlImage] = useState([])
  const [isOpenModalPreview, setIsOpenModalPreview] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [toggledClearRows, setToggleClearRows] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [loc, setLoc] = useState(null)
  const [isDownload, setIsDownload] = useState(false)
  const [firstRows, setFirstRows] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const toggle = () => setIsOpen(!isOpen)

  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  const googleMapsId = process.env.REACT_APP_GOOGLE_MAPS_ID

  const { isLoaded } = useJsApiLoader({
    id: googleMapsId,
    googleMapsApiKey: googleMapsApiKey,
  })

  const handleChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows)
  }

  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows)
    setSelectedRows([])
  }

  const onShowImagePreview = async (item) => {
    try {
      setUrlImage([item])
      setIsOpenModalPreview(true)
    } catch (error) {
      console.error('Terjadi kesalahan saat memuat file dengan token', error)
    }
  }

  const columns = [
    {
      name: <span>Nama Karyawan</span>,
      sortable: true,
      grow: 5,
      sortField: 'verifiedprofile.name',
      cell: (row) => (
        <span data-testid={`attendance-report-row-${row.id}`}>
          {row?.verifiedprofile?.name}
        </span>
      ),
      selector: (row) => row?.verifiedprofile?.name || '-',
      minWidth: '250px',
    },
    {
      name: <span>Tanggal</span>,
      minWidth: '150px',
      sortable: true,
      grow: 2,
      sortField: 'checkIn',
      cell: (row) => {
        const checkin = moment(row?.checkIn)
        const checkout = moment(row?.checkOut)

        if (row?.checkOut && !checkin.isSame(checkout, 'day')) {
          return (
            <div>
              <span className="d-flex flex-column">
                {formatDateOnlyPMB(row?.checkIn)}
              </span>
              -
              <span className="d-flex flex-column">
                {formatDateOnlyPMB(row?.checkOut)}
              </span>
            </div>
          )
        }
        return <span>{formatDateOnlyPMB(row?.checkIn)}</span>
      },
      selector: (row) => {
        const checkin = moment(row?.checkIn)
        const checkout = moment(row?.checkOut)

        if (row?.checkOut && !checkin.isSame(checkout, 'day')) {
          return `${formatDateOnlyPMB(row?.checkIn)} - ${formatDateOnlyPMB(row?.checkOut)}`
        }
        return formatDateOnlyPMB(row?.checkIn) || '-'
      },
    },
    {
      name: <span>Check In</span>,
      minWidth: '150px',
      grow: 3,
      sortable: true,
      sortField: 'checkIn',
      selector: (row) => formatTimeOnlyPMB(row?.checkIn) || '-',
      cell: (row) => (
        <div className="py-2 d-flex flex-column gap-2 flex-wrap">
          <span className="d-flex align-items-center gap-1 text-success">
            <Clock size={12} /> {formatTimeOnlyPMB(row?.checkIn)}
          </span>
          {row?.photoIn ? (
            <>
              <div
                onClick={() => {
                  setLoc({
                    lat: Number(row?.latitudeIn),
                    lng: Number(row?.longitudeIn),
                  })
                  setSelectedRow({ checkIn: true })
                  toggle()
                }}
                className="d-flex align-items-center gap-1 pointer breadcrumb-hover"
              >
                <MapPin size={12} />
                <span>Lokasi</span>
              </div>
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  overflow: 'hidden',
                }}
              >
                <PMBImageWithToken
                  source={row?.photoIn}
                  alt="Photo CheckIn"
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                    cursor: 'pointer',
                  }}
                  className="rounded"
                  onClick={() => {
                    onShowImagePreview(row?.photoIn)
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <div className="d-flex align-items-center gap-1">
                <MapPin size={12} />
                <span>-</span>
              </div>
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={noimage}
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                    objectPosition: 'center',
                  }}
                  className="rounded"
                  alt="noimg"
                />
              </div>
            </>
          )}
        </div>
      ),
    },
    {
      name: <span>Check Out</span>,
      minWidth: '150px',
      grow: 3,
      sortable: true,
      sortField: 'checkOut',
      selector: (row) => formatTimeOnlyPMB(row?.checkOut) || '-',
      cell: (row) => (
        <div className="py-2 d-flex flex-column gap-2 flex-wrap">
          <span className="d-flex align-items-center gap-1 text-danger">
            <Clock size={12} />{' '}
            {row?.checkOut ? formatTimeOnlyPMB(row?.checkOut) : '-'}
          </span>
          {row?.photoOut ? (
            <>
              <div
                onClick={() => {
                  setLoc({
                    lat: Number(row?.latitudeOut),
                    lng: Number(row?.longitudeOut),
                  })
                  setSelectedRow({ checkOut: true })

                  toggle()
                }}
                className="d-flex align-items-center gap-1 pointer breadcrumb-hover"
              >
                <MapPin size={12} />
                <span>Lokasi</span>
              </div>
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  overflow: 'hidden',
                }}
              >
                <PMBImageWithToken
                  source={row?.photoOut}
                  alt="Photo CheckOut"
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                    cursor: 'pointer',
                  }}
                  className="rounded"
                  onClick={() => {
                    onShowImagePreview(row?.photoOut)
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <div className="d-flex align-items-center gap-1">
                <MapPin size={12} />
                <span>-</span>
              </div>
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={noimage}
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                    objectPosition: 'center',
                  }}
                  className="rounded"
                  alt="noimg"
                />
              </div>
            </>
          )}
        </div>
      ),
    },
    {
      name: <span>Durasi Kerja</span>,
      minWidth: '100px',
      grow: 3,
      sortable: true,
      sortField: 'numSecs',
      right: true,
      cell: (row) => (
        <div className="w-full text-end">
          {row?.numSecs ? formatDuration(row?.numSecs) : ''}
        </div>
      ),
      selector: (row) => formatDuration(row?.numSecs) || 0,
    },
    {
      name: <span>Catatan Karyawan</span>,
      minWidth: '150px',
      grow: 4,
      sortable: true,
      sortField: 'notes',
      cell: (row) => {
        const parsedNotes =
          typeof row?.notes === 'string'
            ? JSON.parse(row.notes)
            : row?.notes || []

        return (
          <div className="gap-2 py-1">
            <ExpandableNoteList notes={parsedNotes} />
          </div>
        )
      },
      selector: (row) => {
        const parsedNotes = !row?.notes
          ? []
          : typeof row.notes === 'string'
            ? JSON.parse(row.notes)
            : Array.isArray(row.notes)
              ? row.notes
              : []

        return parsedNotes
          .map((e) => `${formatDateOnlyPMB(e?.ts)} - ${e?.notes}`)
          .join('\n')
      },
    },
    ...(props?.noAction || dataState?.noAction
      ? []
      : [
        {
          name: <span>Catatan Admin</span>,
          minWidth: '150px',
          sortable: true,
          sortField: 'editorNotes',
          grow: 4,
          cell: (row) => {
            const parsedNotes = !row?.editorNotes
              ? []
              : typeof row.editorNotes === 'string'
                ? JSON.parse(row.editorNotes)
                : Array.isArray(row.editorNotes)
                  ? row.editorNotes
                  : []

            return <ExpandableNoteList notes={parsedNotes} />
          },
          selector: (row) => {
            const parsedNotes = !row?.editorNotes
              ? []
              : typeof row.editorNotes === 'string'
                ? JSON.parse(row.editorNotes)
                : Array.isArray(row.editorNotes)
                  ? row.editorNotes
                  : []

            return parsedNotes
              .map((e) => `${formatDateOnlyPMB(e?.ts)} - ${e?.notes}`)
              .join('\n')
          },
        },
      ]),
    {
      name: <span>Status</span>,
      minWidth: '150px',
      grow: 3,
      sortable: true,
      sortField: 'status',
      center: true,
      selector: (row) => {
        if (row.status?.toLowerCase() === 'notverified') {
          return 'Belum Terverifikasi'
        } else {
          return 'Terverifikasi'
        }
      },
      cell: (row) => {
        if (row.status?.toLowerCase() === 'notverified') {
          return (
            <div
              className="badge rounded-pill bg-danger-50 text-danger px-2"
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              Belum Terverifikasi
            </div>
          )
        } else {
          return (
            <div
              className="badge rounded-pill bg-success-50 text-success px-2"
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              Terverifikasi
            </div>
          )
        }
      },
    },
    ...(props?.noAction || dataState?.noAction
      ? []
      : [
        {
          name: '',
          grow: 1,
          minWidth: '80px',
          cell: (row) => (
            <Can I={MANAGE} this={BUSINESS_ATTENDANCE_DASHBOARD}>
              <Edit
                size={17}
                onClick={() => {
                  setSelectedRow(row)
                  dispatch(toggleModal())
                }}
                className="text-secondary pointer"
                data-testid={`attendance-report-edit-${row.id}`}
              />
            </Can>
          ),
        },
      ]),
  ]

  const handleSort = (column, direction) => {
    dispatch(
      setFetchOption({
        sortby: column.sortField,
        sortdir: direction?.toUpperCase(),
      }),
    )
  }

  const debouncedSearch = useDebounce((value) => {
    dispatch(
      setFetchOption({
        page: 0,
        s: value,
      }),
    )
  }, 600)

  const onHandleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && tag?.s.length === 0) {
      e.preventDefault()
    }
  }

  return (
    <>
      <PMBProgressBarExportFile
        isDialogShow={isDownload}
        firstRows={firstRows}
        totalRows={totalRows}
        onCancel={() => setIsDownload(false)}
      />
      {isLoaded && (
        <Modal centered size="lg" toggle={toggle} isOpen={isOpen}>
          <ModalBody>
            <h6>Lokasi {selectedRow?.checkIn ? 'Check In' : 'Check Out'}</h6>
            {loc && (
              <GoogleMap
                zoom={16}
                center={loc}
                mapContainerStyle={{ width: '100%', height: '60vh' }}
              >
                <Marker position={loc} />
              </GoogleMap>
            )}
          </ModalBody>
        </Modal>
      )}

      <PMBModalImagePreview
        isOpen={isOpenModalPreview}
        toggle={() => {
          setIsOpenModalPreview(false)
          setUrlImage([])
        }}
        images={urlImage}
        isDownload
      />
      <ModalEditAttendance row={selectedRow} refetch={props?.refetch} />
      <ModalVerifyAttendance
        row={selectedRows}
        refetch={() => {
          props.refetch()
          handleClearRows()
        }}
      />
      <div className="d-flex flex-column gap-2 mb-2">
        <Card className="border-0">
          <CardBody className={props?.noPadding ? 'p-0' : ''}>
            {(props?.title || props?.subTitle) && (
              <div>
                <h5>{props.title}</h5>
                <p>{props.subTitle}</p>
              </div>
            )}
            <TableComponent
              selectableRows={!(props?.noAction || dataState?.noAction)}
              onSelectedRowsChange={handleChange}
              clearSelectedRows={toggledClearRows}
              columns={columns}
              data={props?.data?.items}
              progressPending={props?.loading || loading}
              sortServer
              defaultSortFieldId={1}
              defaultSortAsc={false}
              sortIcon={<ChevronDown />}
              onSort={handleSort}
              pagination
              paginationServer
              paginationComponent={() => (
                <PMBPagination
                  rowCount={props?.data?.totalItems || 0}
                  currentPage={tag?.page}
                  rowsPerPage={tag?.size}
                  setCurrentPage={(e) => {
                    dispatch(setFetchOption({ page: e }))
                  }}
                  setRowsPerPage={(e) => {
                    dispatch(setFetchOption({ size: e }))
                  }}
                  testId="attendance-report-pagination"
                />
              )}
              subHeader
              subHeaderComponent={
                <div className="d-flex flex-wrap w-100 justify-content-between gap-3 mb-3">
                  <div className="d-flex flex-wrap gap-3">
                    <PMBSearchInputGroup
                      label="Cari"
                      value={searchInput}
                      placeholder="Cari..."
                      onChange={(e) => onHandleSearchChange(e.target.value)}
                      maxWidth="100%"
                      onKeyDown={handleKeyDown}
                      testId="attendance-report-search-input"
                    />

                    {props?.showDate && (
                      <div style={{ width: '100%', maxWidth: '100%' }}>
                        <PMBDateRangePicker
                          style={{ width: '100%', maxWidth: '100%' }}
                          value={tag?.from && tag?.to ? [tag.from, tag.to] : []}
                          onChange={(dates) => {
                            if (dates?.length === 2) {
                              dispatch(
                                setFetchOption({
                                  from: dates[0],
                                  to: dates[1],
                                }),
                              )
                            }
                          }}
                          format="yyyy-mm-dd"
                          onClear={() =>
                            dispatch(
                              setFetchOption({
                                from: props?.defaultDateRange?.[0],
                                to: props?.defaultDateRange?.[1],
                              }),
                            )
                          }
                          data-testid="attendance-report-date-range"
                        />
                      </div>
                    )}
                  </div>

                  <div className="d-flex align-items-end gap-2">
                    <CustomButton
                      onClick={async () =>
                        handleDownloadExcel(
                          // Refetch all rows matching the filters, not just this page
                          await triggerFetchForDownload({
                            ...props?.queryArgs,
                            page: 0,
                            size: props?.data?.totalItems,
                          }).unwrap(),
                          setIsDownload,
                          setFirstRows,
                          setTotalRows,
                          columns,
                          props.title,
                          [tag?.from, tag?.to],
                        )
                      }
                      color="primary"
                      outline
                      disabled={props?.data?.totalItems < 1}
                      testId="attendance-report-download-button"
                    >
                      <Download size={15} /> Download
                    </CustomButton>

                    {!(props?.noAction || dataState?.noAction) && (
                      <Can I={MANAGE} this={BUSINESS_ATTENDANCE_DASHBOARD}>
                        <CustomButton
                          color="primary"
                          onClick={() => dispatch(toggleModalVerify())}
                          disabled={selectedRows?.length < 1}
                          testId="attendance-report-verify-button"
                        >
                          Verifikasi Sekaligus
                        </CustomButton>
                      </Can>
                    )}
                  </div>
                </div>
              }
            />
          </CardBody>
        </Card>
      </div>
    </>
  )
}

export default TableReport
